export default __webpack_public_path__ + "static/media/object-icon.eed5436c.png";